import {
    RECEIVE_CREATE_ACTIVITY,
    REQUEST_CREATE_ACTIVITY,
    UPDATE_CREATE_ACTIVITY_VALUES,
    CLEAR_CREATE_ACTIVITY_VALUES
} from "../constants/actionTypes"

import { Scoring } from '../constants/scoring';

const initialState = {
    activityName: "",
    sequenceName: "",
    sceneName: "",
    instructionalName: "",
    description: "",
    product: "english",
    scores: Scoring.ScoresDoesNotScore,
    activityNameValid: false,
    productValid: false,
    showModal: false,
    hideModal: false,
    isRequesting: false
}

export const createActivityData = (state = initialState, action) => {
    switch(action.type) {
        case UPDATE_CREATE_ACTIVITY_VALUES:{
            let newState = {
                ...state,
                ...action.values
            };

            if(newState.activityName != null){
                newState.sequenceName = newState.activityName;
                newState.sceneName = newState.activityName.toLowerCase();
            }

            return newState;
        }

        case REQUEST_CREATE_ACTIVITY:{
            return {
                ...state,
                isRequesting: true
            }
        }

        case CLEAR_CREATE_ACTIVITY_VALUES:{
            return initialState;
        }

        case RECEIVE_CREATE_ACTIVITY:{
            return {
                ...state,
                hideModal: true,
                isRequesting: false
            }
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/createActivityData.js